import {
  List, Datagrid, TextField, TopToolbar, ExportButton, EditButton,
  CreateButton, useRecordContext, FunctionField, TextInput,
  editFieldTypes,
} from "react-admin";
import { BulkDeleteButton } from 'react-admin';
import { downloadCSV } from "react-admin";
import jsonExport from "jsonexport/dist";
import { useNotify, useRefresh } from "react-admin";
import UploadButton from "../../components/UploadButton.tsx";
import DeleteWithConfirmButton from "../../components/DeleteWithConfirmButton.tsx";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import { ellipsisCell } from '../../styles/ellipsis.ts';
import TemplateDownloadButton from "../../components/TemplateDownloadButton.tsx";
const exporter = (records) => {
  const data = records.map((record) => ({
    productId: record.productId,
    name: record.name,
    grassValue: record.grassValue,
    // supplier: record.supplier,
    // 仅导出需要的字段
  }));

  jsonExport(data, (err, csv) => {
    if (err) {
      console.error(err);
    } else {
      downloadCSV(csv, "products_export"); // 导出的文件名
    }
  });
};
const productFilters = [
  <TextInput sx={{
    '& .MuiInputBase-input': {
      height: 40,      // 输入框高度
      padding: '6px 12px',
      fontSize: 14,
      lineHeight: '40px', // 使文字垂直居中
    },
    minHeight: 36,      // 整体高度
    marginBottom: '16px',
  }} label="Search For Product ID" source="productId" alwaysOn resettable />,

];

const ListActions = () => {
  const notify = useNotify();
  const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5180/api';

  const fetchSAPMaterialData = async () => {
    // 立即通知用户操作已开始
    notify("SAP Material 数据获取已开始，稍后将通过邮件通知结果", { type: "info" });

    try {
      const token = localStorage.getItem("token"); // 获取 token
      await fetch(`${API_URL}/materials/sap`, {
        method: "GET",
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${token}`, // 添加 Authorization 头
        },
      });

      // 不需要等待接口完成后再通知用户.
    } catch (error) {
      console.error(error);
      notify("获取 SAP Material 数据失败，请稍后重试", { type: "error" });
    }
  };
  return (
    <TopToolbar sx={{
      marginBottom: '16px',
    }}>

      <TemplateDownloadButton href="/templates/product_template.csv" />
      <UploadButton onSuccess={() => window.location.reload()} resource="prodocProducts" />

      <CreateButton sx={{
        textTransform: 'capitalize', top: '-5px', '& span': {

          marginRight: '2px',
        }
      }} />
    </TopToolbar>
  );
};

// 自定义操作列，把编辑和删除按钮合并一行显示
const ActionButtons = ({ record }: { record?: any }) => {
  const contextRecord = useRecordContext();
  const rec = record ?? contextRecord;
  if (!rec) return null;

  return (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      gap: '8px',
      width: '100%',
      textAlign: 'center',
    }}>
      <EditButton record={rec} sx={{
        '& .MuiButton-startIcon': {
          marginRight: 0, // 默认是8px，可以缩小为4px或者更小
        }, textTransform: 'capitalize'
      }} />
      <DeleteWithConfirmButton record={rec} resource="prodocProducts" sx={{
        '& .MuiButton-startIcon': {
          marginRight: 0, // 默认是8px，可以缩小为4px或者更小
        }
      }} />
    </div>
  );
};


const ProductList = (props) => (

  <List
    sx={{ marginTop: '20px', padding: '0 16px' }}
    empty={false}
    filters={productFilters}
    exporter={exporter} // 使用自定义导出函数
    {...props} actions={<ListActions />}>


    <Datagrid rowClick={false} isRowSelectable={() => true} bulkActionButtons={<BulkDeleteButton label="批量删除" />}
      sx={{

        '& .RaDatagrid-headerCell': {
          textAlign: 'center',
        },
        '& .RaDatagrid-rowCell': {
          textAlign: 'center',
        },
      }}>
      {/* <TextField source="id" /> */}
      <TextField source="productId" sx={ellipsisCell} label="Product ID" />
      <TextField source="name" />

      <TextField source="grossWeight" />
      <TextField source="netWeight" />
      <TextField source="cube" />
      <TextField source="cartonSize" />
      <TextField source="productPrice" />


      <FunctionField
        label="Operations"
        render={record => <ActionButtons record={record} />}
      />
    </Datagrid>

  </List >
);

export default ProductList;
